var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankCustodianIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24.8712V28.8712C17.5 29.7012 18.17 30.3712 19 30.3712C19.83 30.3712 20.5 29.7012 20.5 28.8712V24.8712C20.5 24.0412 19.83 23.3712 19 23.3712C18.17 23.3712 17.5 24.0412 17.5 24.8712ZM23.5 24.8712V28.8712C23.5 29.7012 24.17 30.3712 25 30.3712C25.83 30.3712 26.5 29.7012 26.5 28.8712V24.8712C26.5 24.0412 25.83 23.3712 25 23.3712C24.17 23.3712 23.5 24.0412 23.5 24.8712ZM17 35.3712H33C33.83 35.3712 34.5 34.7012 34.5 33.8712C34.5 33.0412 33.83 32.3712 33 32.3712H17C16.17 32.3712 15.5 33.0412 15.5 33.8712C15.5 34.7012 16.17 35.3712 17 35.3712ZM29.5 24.8712V28.8712C29.5 29.7012 30.17 30.3712 31 30.3712C31.83 30.3712 32.5 29.7012 32.5 28.8712V24.8712C32.5 24.0412 31.83 23.3712 31 23.3712C30.17 23.3712 29.5 24.0412 29.5 24.8712ZM24.07 14.8612L16.17 19.0212C15.76 19.2312 15.5 19.6612 15.5 20.1212C15.5 20.8112 16.06 21.3712 16.75 21.3712H33.26C33.94 21.3712 34.5 20.8112 34.5 20.1212C34.5 19.6612 34.24 19.2312 33.83 19.0212L25.93 14.8612C25.35 14.5512 24.65 14.5512 24.07 14.8612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCustodianIcon);
export default __webpack_public_path__ + "static/media/bank_custodian_icon.c9c3b5f262eb67d6b07b2d8fb0e3ec37.svg";
export { ForwardRef as ReactComponent };